// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__3Gmzq","inner":"Footer_inner__1jcDU"};